export enum CompletionTargetAudienceEnum {
    GENERAL_PUBLIC = 'GENERAL_PUBLIC',
    INTERNAL_PR_TEAM = 'INTERNAL_PR_TEAM',
    INTERNAL_STAKEHOLDERS = 'INTERNAL_STAKEHOLDERS',
    EXTERNAL_STAKEHOLDERS = 'EXTERNAL_STAKEHOLDERS',
    EMPLOYEES = 'EMPLOYEES',
    JOURNALISTS = 'JOURNALISTS',
    CONSUMERS = 'CONSUMERS',
    CUSTOMERS = 'CUSTOMERS',
    FANS = 'FANS',
    ACADEMICS = 'ACADEMICS',
    YOUTH = 'YOUTH',
    FRIENDS = 'FRIENDS',
    ADVERSARIES = 'ADVERSARIES',
    CUSTOM = 'CUSTOM'
};
